// Frontend-only theme preference — no backend/API involved. Follows this app's existing
// convention (see AppShell/index.js's firstName/lastName/photoUrl) of a plain localStorage key
// read via a lazy useState initializer, rather than introducing a new state-management library
// just for one boolean-ish preference.
const THEME_STORAGE_KEY = "hf-theme";

export function getStoredTheme() {
  return localStorage.getItem(THEME_STORAGE_KEY) === "dark" ? "dark" : "light";
}

// Applies the theme to the document immediately — pure CSS (see theme.css's
// `:root[data-theme="dark"]` override), so this takes effect the instant the attribute is set,
// no React re-render required anywhere else in the tree.
export function applyTheme(theme) {
  document.documentElement.setAttribute("data-theme", theme);
}

export function setStoredTheme(theme) {
  localStorage.setItem(THEME_STORAGE_KEY, theme);
  applyTheme(theme);
}
